import Venue from "types/models/Venue";
import { getCloverPointsByCodes } from "services/paymentsServices";
import Commerce from "types/models/Commerce";
import { CloverPointConnectionStatusType } from "types/enums/CloverPointConnectionStatusType";
import CloverPoint from "types/models/CloverPoint";
import CloverConnectionStatuses from "types/models/CloverConnectionStatuses";

interface UseCloverPointsProps {
  currentVenue: Venue | null;
  isCommerceEditor?: boolean;
  setCurrentVenue?: (venue: Venue) => void;
  setIsLoading?: (isLoading: boolean) => void;
}

export function useCloverPoints({ 
    currentVenue, 
    isCommerceEditor, 
    setCurrentVenue,
    setIsLoading
}: UseCloverPointsProps) {
    const fetchCloverPointsByCodes = async () => {
        if (!currentVenue) return;
        if (!setCurrentVenue) return;
        if (!setIsLoading) return;
        if (isCommerceEditor) return;
    
        try {
          setIsLoading(true);
          const commerceCodes = currentVenue.commerces.map((commerce) => commerce.code);
          const data = await getCloverPointsByCodes({
            codes: [...commerceCodes, currentVenue.code],
            connectionStatuses: [],
            connectionTypes: [],
            getAll: true,
          });
    
          if (data.length === 0) return;
    
          const commercesWithCloverPoints = currentVenue.commerces.map((commerce) => {
            const commerceCloverPoints = data.filter((cloverPoint) => cloverPoint.pairingOriginCode === commerce.code);
            return {...commerce, cloverPoints: commerceCloverPoints};
          });
    
          const venueCloverPoints = data.filter((cloverPoint) => cloverPoint.pairingOriginCode === currentVenue.code);
          // Estados de Clovers para el venue => Antes se mostraba el estado de los clovers enlazados a nivel venue. 
          // Ahora se muestra el estado de todos los clovers enlazados a nivel venue y a nivel de comercio
          const commerceCloverPoints = commercesWithCloverPoints.map((commerce) => commerce.cloverPoints).flat();
          const allCloverPoints = [...venueCloverPoints, ...commerceCloverPoints];

          setCurrentVenue({...currentVenue, commerces: commercesWithCloverPoints, cloverPoints: allCloverPoints});
        } catch (error) {
console.error(error)
        } finally {
          setIsLoading(false);
        }
      };

    const cloverStatusesCount = (
        entity: Commerce | Venue | null,
        cloverPoints?: CloverPoint[]
        ): CloverConnectionStatuses => {
        const statuses = { online: 0, unstable: 0, offline: 0, whitoutPaper: 0, isInactive: 0 };

        if (!cloverPoints){
          cloverPoints = entity?.cloverPoints || [];
        };

        cloverPoints.forEach((cloverPoint) => {
          
            if(!cloverPoint.isActive) {
              statuses.isInactive += 1;
            }else{
              switch (cloverPoint.deviceConnectionStatus) {
              case CloverPointConnectionStatusType.CONNECTED:
                  statuses.online += 1;
                  break;
              case CloverPointConnectionStatusType.UNSTABLE:
                  statuses.unstable += 1;
                  break;
              case CloverPointConnectionStatusType.DISCONNECTED:
                  statuses.offline += 1;
                  break;
              }
              if (!cloverPoint.deviceHasPaper) {
                statuses.whitoutPaper += 1;
              }
            }
        });

  return statuses;
};

    return {
        fetchCloverPointsByCodes,
        cloverStatusesCount
    };
}